import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import ValidationService from "@/services/ValidationService";

export default {
  name: "reportCardGradingImport",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
  },
  mixins: [ValidationService],

  data() {
    return {
      isLoading: false,
      isInitialLoad: true,
      acdYearList: [],
      termList: [],
      gradeList: [],
      classList: [],
      studentList: [],
      acdYearId: null,
      termId: null,
      gradeId: null,
      classId: null,
      studentIds: [],
      file_name: '',
      invalidFile: false,
      invalidFileSize: false,
      submitted: false,
      disableImportBtn: false,
      disableInputFields: false,
    };
  },

  validations: {
    acdYearId: { required },
    termId: { required },
    gradeId: { required },
    classId: { required },
    studentIds: { required },
    file_name: { required },
  },

  computed: {
    disabledTemplateBtn() {
      if (!this.termId || !this.gradeId || !this.classId) {
        return true;
      }
      
      if (this.studentList && this.studentList.length > 0) {
        const hasValidStudents = this.studentList.some(s => s.id !== '' && s.id !== 'all');
        
        if (!hasValidStudents) {
          return true;
        }
        
        const hasValidSelection = this.studentIds && this.studentIds.length > 0;
        return !hasValidSelection;
      }
      
      return true;
    },
    hasStudentsInClass() {
      return this.studentList && this.studentList.some(s => s.id !== '' && s.id !== 'all');
    },
  },

  watch: {
    acdYearId(newVal) {
        this.gradeId = null;
        this.termId = null;
        this.classId = null;
        this.gradeList = [];
        this.termList = [];
        this.classList = [];
        this.studentList = [];
        this.studentIds = [];
        
        if (!newVal) return;
        
        this.getTermListByAcademicYear(newVal);
        this.getGradeList(newVal);
    },

    termId() {
      this.studentIds = [];
    },

    gradeId(newVal) {
      this.classId = null;
      this.classList = [];
      this.studentList = [];
      this.studentIds = [];
      if (!newVal) return;
      this.getClassList(newVal);
    },

    classId(newVal) {
      this.studentIds = [];
      if (!newVal) return;
      this.getStudentList(newVal);
    },
  },

  methods: {
    async getParentAcdYearList() {
      try {
        this.isLoading = true;
        const response = await axios.get('score-setting/parent-acd-year');
        if (response.data) {
          const rawData = response.data.data;
          this.acdYearList = rawData.map(item => ({
            id: item.id,
            text: item.period_name,
          }));
          const activeId = response.data.active_acd_year_id;
          this.acdYearId = activeId ?? this.acdYearList?.[0]?.id ?? null;
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getTermListByAcademicYear(acdYearId) {
      try {
        this.isLoading = true;
        const response = await axios.get(`period/${acdYearId}/term/list`);
        if (response.data && response.data.terms) {
          this.termList = response.data.terms.map(item => ({
            id: item.id,
            text: item.term_name,
            acd_year_id: item.acd_year_id,
          }));
          if (this.termList.length > 0) {
            this.termId = this.termList[0].id;
          }
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getGradeList(acdYearId) {
      try {
        this.isLoading = true;
        const response = await axios.get('campusGrade/listByAcdYear', {
          params: { acd_year_id: acdYearId },
        });
        if (response.data) {
          const data = response.data.data || [];
          this.gradeList = data.map(item => ({
            id: item.id,
            text: item.text,
          }));
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getClassList(campusGradeId) {
      var request = {
        params: {
          campus_id: this.$store.state.user.campus_id,
          campus_grade_id: campusGradeId
        }
      }

      axios
        .get("/class/sectionList", request)
        .then((response) => {
          if (response.data) {
            const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
            this.classList = data.map(item => ({
              id: item.id,
              text: item.text ?? item.class_name,
            }));
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Section API Error", error);
        });
    },

    async getStudentList(classId) {
      var request = {
        params: {
          class_id: classId,
        }
      }
      axios.get("/report-card-grading-item/students", request)
        .then((response) => {
          if (response.data) {
            const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
            const students = data.map(item => ({
              id: item.id,
              text: item.text,
            }));
            
            if (students.length > 0) {
              this.studentList = [
                { id: 'all', text: 'All Students' },
                ...students
              ];
            } else {
              this.studentList = [
                { id: '', text: 'No students available in this class' }
              ];
            }
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    async templateDownload() {
      if (this.disabledTemplateBtn) return;
      this.isLoading = true;
      this.disableInputFields = true;

      let studentIdsToSend = [...this.studentIds];
      if (studentIdsToSend.includes('all')) {
        studentIdsToSend = this.studentList
          .filter(s => s.id !== 'all' && s.id !== '')
          .map(s => s.id);
      }

      const request = {
        term_id: this.termId,
        campus_grade_id: this.gradeId,
        class_id: this.classId,
        student_id: studentIdsToSend.length > 0 ? studentIdsToSend : null,
      };

      try {
        const response = await axios({
          method: 'get',
          url: '/report-card-grading-item/template-download',
          params: request,
          responseType: 'blob',
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `report_card_grading_template.xlsx`;
        link.click();
      } catch (error) {
        this.handleError(error);
        this.$notification.error("Failed to download template.", {
          timer: 3, position: "bottomCenter",
        });
      } finally {
        this.isLoading = false;
      }
    },

    chooseFile() {
      this.$refs.fileUploader.value = null;
      this.file_name = '';
      this.$refs.fileUploader.click();
      this.submitted = false;
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      const allowedTypes = ['.xls', '.xlsx'];
      const ext = file.name.split('.').pop().toLowerCase();
      if (!allowedTypes.includes(`.${ext}`)) {
        this.invalidFile = true;
        this.file_name = '';
        this.$notification.error('File type not supported!', {
          timer: 3, position: 'bottomCenter',
        });
        return;
      }
      this.invalidFile = false;
      this.file_name = file.name;
    },

    async confirmImport() {
      this.submitted = true;
      if (this.$v.$invalid) return;
      this.validationErrors = {};
      this.clearValidationErrors();

      const file = this.$refs.fileUploader.files[0];
      if (!file) {
        this.invalidFile = true;
        this.file_name = '';
        return;
      }
      const MAX_SIZE = 2 * 1024 * 1024; // 2MB
      if (file.size > MAX_SIZE) {
        this.invalidFileSize = true;
        return;
      }
      this.invalidFileSize = false;
      await this.doImport();
    },

    async doImport() {
      this.isLoading = true;
      this.disableImportBtn = true;
      this.validationErrors = {};
      this.clearValidationErrors();
      const formData = new FormData();
      
      formData.append('term_id', this.termId);
      formData.append('campus_grade_id', this.gradeId);
      formData.append('class_id', this.classId);
      
      let studentIdsToSend = [...(this.studentIds || [])];
      if (studentIdsToSend.includes('all')) {
        studentIdsToSend = this.studentList
          .filter(s => s.id !== 'all' && s.id !== '')
          .map(s => s.id);
      }
      
      if (studentIdsToSend.length > 0) {
        studentIdsToSend.forEach((id) => {
          formData.append('student_id[]', id);
        });
      }
      formData.append('file', this.$refs.fileUploader.files[0]);

      try {
        const response = await axios.post('/report-card-grading-item/import', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.status === 200) {
          this.$notification.success("Report card grading imported successfully", {
            timer: 3, position: "bottomCenter",
          });
          this.showList();
        }
      } catch (error) {
        if (!error.response) {
          this.$notification.error("Something went wrong. Please re-select the file and try again.", {
            timer: 3, position: "bottomCenter",
          });
          this.file_name = '';
          this.$refs.fileUploader.value = null;
          this.submitted = false;
        } else if (error.response.status === 422) {
          if (error.response.data && error.response.data.success === false) {
            alert(error.response.data.msg);
          } else {
            this.printValidationError(error.response);
          }
        } else {
          this.handleError(error);
        }
      } finally {
        this.disableImportBtn = false;
        this.isLoading = false;
      }
    },

    resetAll() {
      this.submitted = false;
      this.disableInputFields = false;
      this.isInitialLoad = true;
      this.acdYearId = null;
      this.termId = null;
      this.gradeId = null;
      this.classId = null;
      this.studentIds = [];
      this.studentList = [];
      this.gradeList = [];
      this.classList = [];
      this.file_name = '';
      this.invalidFile = false;
      this.invalidFileSize = false;
      this.validationErrors = {};
      this.clearValidationErrors();
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.value = null;
      }
      this.getParentAcdYearList();
      this.getTermListByAcademicYear(this.acdYearId);
    },

    showList() {
      this.$router.push({ path: '/report-card-grading' });
    },

    handleError(error) {
      if (error.response && error.response.status === 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      } else {
        console.error(error);
      }
    },
  },

  mounted() {
    this.getParentAcdYearList();
  },
};
